import { IAuthUser } from '@/store/modules/auth/interfaces/IAuthUser'
import { permissionSchema, RolePermissionDetails } from '@/store/modules/users/interfaces/IUser'

export default {
  methods: {
    allPermission (user: IAuthUser) {
      const permissionSchema = user?.permissionSchema
      return (
        permissionSchema
          ?.flatMap((company: permissionSchema) => company.rpDetails)
          ?.flatMap((rp: RolePermissionDetails) => rp.permission.split(','))
          ?.filter((value: string, index: number, self: Array<string>) => self.indexOf(value) === index) || []
      )
    },
    shipToAllPermission (user: IAuthUser, shipToId : string) {
      const permissionSchema = user?.permissionSchema?.filter((company) => company.shipToId === shipToId) || []
      return (
        permissionSchema
          ?.flatMap((company: permissionSchema) => company.rpDetails)
          ?.flatMap((rp: RolePermissionDetails) => rp.permission.split(','))
          ?.filter((value: string, index: number, self: Array<string>) => self.indexOf(value) === index) || []
      )
    },
    allRoles (user: IAuthUser) {
      const permissionSchema = user?.permissionSchema
      return (
        permissionSchema
          ?.flatMap((company: permissionSchema) => company.rpDetails)
          ?.flatMap((rp: RolePermissionDetails) => rp.rolename)
          ?.filter((value: string, index: number, self: Array<string>) => self.indexOf(value) === index) || []
      )
    },
    allShipToBasicRoles (user: IAuthUser, shipToId: string) {
      const permissionSchema = user?.permissionSchema?.filter((company) => company.shipToId === shipToId) || []
      return (
        permissionSchema
          ?.flatMap((company: permissionSchema) => company.rpDetails)
          ?.filter((rp: RolePermissionDetails) => rp.roleType === 'Basic')
          ?.flatMap((rp: RolePermissionDetails) => rp.rolename)
          ?.filter((value: string, index: number, self: Array<string>) => self.indexOf(value) === index) || []
      )
    },
    allCompanyDetails (user: IAuthUser) {
      const permissionSchema = user?.permissionSchema
      return permissionSchema.map((item: permissionSchema) => {
        return { label: item.companyName, value: item.companyId }
      })
    },
    shipToDetails (user: IAuthUser) {
      const permissionSchema = user?.permissionSchema
      return permissionSchema.map((item: permissionSchema) => {
        return { label: item.shipToName, value: item.shipToId }
      })
    },
    checkDisableShipTo (user: IAuthUser, shipToId: string) {
      const permissionSchema = user?.permissionSchema || []

      if (shipToId != null) {
        return permissionSchema.some(
          (shipToItem: permissionSchema) => shipToItem.shipToId === shipToId && shipToItem.shipToStatus === 'SUSPENDED'
        )
      }

      if (permissionSchema.length === 1) {
        return permissionSchema[0]?.shipToStatus === 'SUSPENDED'
      }

      return false
    },
    getCompanyid (shipToId: string, user: IAuthUser) {
      let companyId = ''
      const shipToItem = user?.permissionSchema.find((item: permissionSchema) => item.shipToId === shipToId)
      if (shipToItem) {
        companyId = shipToItem?.companyId
      }
      return companyId
    }
  }
}
export const getAccessToken = (): string => {
  return sessionStorage.getItem('id_token') || ''
}

export const getBearerToken = (): string => {
  const token = getAccessToken()

  return token ? `Bearer ${token}` : ''
}
